// package imports
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import {
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { Theme as MuiTheme } from '@mui/material/styles';

// local imports
import { ObsStyles } from '../../StyledComponents';
import { useObservationStore } from 'components/agility-pageModules/observation/stores/observationStore';
import { useSessionStorage } from 'services/hooks/useSessionStorage';

const NOTE_TYPE = {
  POSITIVE: 'Positive',
  DELTA: 'Delta',
};

const SessionNote: React.FC<{ theme: MuiTheme }> = ({ theme }) => {
  const styles = ObsStyles(theme);

  const [note, setNote] = useSessionStorage('sessionNote', '');
  const [noteType, setNoteType] = useSessionStorage(
    'sessionNoteType',
    NOTE_TYPE.POSITIVE,
  );
  const { addTimelineObservation } = useObservationStore();

  const addToTimeline = () => {
    let validType: 'Session Note - Positive' | 'Session Note - Delta' =
      'Session Note - Positive';
    if (noteType === NOTE_TYPE.DELTA) {
      validType = 'Session Note - Delta';
    }
    const timelineNote = {
      timestamp: new Date().getTime(),
      session_minute: null,
      type: validType,
      tags: [] as string[],
      note: note,
    };
    if (note?.length > 0) {
      timelineNote.tags.push(note.toUpperCase());
    }
    if (timelineNote.tags.length > 0) {
      addTimelineObservation(timelineNote);
      setNote('');
      setNoteType(NOTE_TYPE.POSITIVE);
    }
  };

  const handleNoteTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNoteType((event.target as HTMLInputElement).value);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <FormControl fullWidth size="small">
          <TextField
            placeholder="Type note"
            multiline={true}
            rows={2}
            sx={{ ...styles.select, marginTop: '.75rem' }}
            label="New Session Note"
            id="session-note"
            size="small"
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
            }}
            slotProps={{
              input: { sx: { ...styles.select } },
              htmlInput: { maxLength: 500 },
              inputLabel: { shrink: true }
            }} />
        </FormControl>

        <IconButton
          onClick={addToTimeline}
          style={{ marginTop: '.5rem' }}
          disabled={note.length === 0}
          aria-label="Add session note"
        >
          <ArrowCircleRightIcon
            sx={{ color: theme.palette.gold.main }}
            fontSize="large"
          />
        </IconButton>
      </Box>
      <FormControl>
        <RadioGroup
          row
          name="note-type"
          defaultValue={NOTE_TYPE.POSITIVE}
          value={noteType}
          onChange={handleNoteTypeChange}
        >
          <FormControlLabel
            sx={{ '& .MuiTypography-root': { fontSize: '.875rem' } }}
            control={<Radio size="small" />}
            value={NOTE_TYPE.POSITIVE}
            label={NOTE_TYPE.POSITIVE}
          />
          <FormControlLabel
            sx={{ '& .MuiTypography-root': { fontSize: '.875rem' } }}
            control={<Radio size="small" />}
            value={NOTE_TYPE.DELTA}
            label={NOTE_TYPE.DELTA}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default SessionNote;
